import { MultiValueGenericProps, components } from 'react-select';
import { ComboboxOptions } from '../types';

export const MultiValueContainer = (props: MultiValueGenericProps<ComboboxOptions[0]>) => {
  return <components.MultiValueContainer {...props}>{props.children}</components.MultiValueContainer>;
};
